<template>
  <div class="">
    <StepHeader
      :title="title"
      :theme="theme"
    />

    <StepContent :theme="theme">
      <div
        v-if="searchVersion==='v2'"
      >
        <AppAddressSearch v-if="!addressFallback" />
        <AppCanadaPostFallback
          v-if="addressFallback"
          :theme="theme"
          @fallback-validated="$emit('fallback-validated')"
        />
      </div>
      <div
        v-else
        ref="observer"
      >
        <AppCanadaPost
          :theme="theme"
        />
      </div>
    </StepContent>

    <StepFooter hide-mobile>
      <AppButton
        :theme="theme"
        :loading="submitting"
        @click="handleContinue"
      >
        Continue
      </AppButton>
    </StepFooter>
  </div>
</template>

<script>
import AppButton from '@/components/common/buttons/AppButton'
import StepContent from '@/components/common/step-layout/StepContent'
import StepFooter from '@/components/common/step-layout/StepFooter'
import StepHeader from '@/components/common/step-layout/StepHeader'
import navigation from '@/mixins/navigation'
import theme from '@/mixins/theme'
import submitLoans from '@/mixins/submit/submit-loans'
import step from '@/mixins/step'
import AppAddressSearch from '@/components/common/address/AppAddressSearch'
import AppCanadaPostFallback from '@/components/common/canada-post/AppCanadaPostFallback'
import AppCanadaPost from '@/components/common/canada-post/AppCanadaPost'

export default {
  // Name
  name: 'HomeAddress',

  // Components
  components: {
    AppButton,
    StepContent,
    StepFooter,
    StepHeader,
    AppAddressSearch,
    AppCanadaPostFallback,
    AppCanadaPost
  },

  // Mixins
  mixins: [
    submitLoans,
    navigation,
    theme,
    step
  ],

  // Props
  props: {
    title: {
      type: String,
      default: 'What Is Your Home Address?'
    },

    // Temporary for AB testing purposes
    searchVersion: {
      type: String,
      default: 'v2'
    }
  },

  // Computed
  computed: {
    locationState () {
      return this.$store.state.location
    },

    addressFallback () {
      return this.locationState.addressFallback
    },

    fallBackDataCompleted () {
      return this.$store.getters.fallbackDataCompleted
    },

    postalCode () {
      return this.locationState.c_post_PostalCode || this.locationState.postal_code
    },

    city () {
      return this.locationState.c_post_City || this.locationState.city
    },

    dataLayerObject () {
      return {
        event: !this.addressFallback ? `spring_${this.eventPrefix}_address_continue` : `spring_${this.eventPrefix}_address_manual_continue`,
        postalCode: this.postalCode,
        city: this.city
      }
    },

    debouncedValue () {
      return this.inputValue
    }
  },

  watch: {
    $_navigation_triggerContinue: async function (val) {
      this.$store.dispatch('setInputFocused', false)
      if (val) await this.handleContinue(this.locationState, this.dataLayerObject)
      this.$store.dispatch('setTriggerContinue', false)
    }
  },

  created () {
    if (!this.fallBackDataCompleted) { this.$store.dispatch('setAddressFallback', false) }
  },

  methods: {
    async handleContinue () {
      this.submitted = true
      const isValid = await this.$_navigation_validateStep()
      if (!isValid) return
      this.$_step_handleContinue(this.locationState, this.dataLayerObject)
    }
  }
}
</script>
